import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useGetBanners from "../libs/useGetbannersFormmk";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "./Banner.css";

const NextArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={`${className || ""} custom-arrow right-arrow`}
    style={style}
    onClick={onClick}
    aria-label="Next slide"
  >
    <FontAwesomeIcon icon={faChevronRight} />
  </button>
);

const PrevArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={`${className || ""} custom-arrow left-arrow`}
    style={style}
    onClick={onClick}
    aria-label="Previous slide"
  >
    <FontAwesomeIcon icon={faChevronLeft} />
  </button>
);

const BannerSlide = ({ banner }) => {
  const alt = banner.altText || "Marketplace banner";
  const img = <img src={banner.imageUrl} alt={alt} />;

  if (!banner.linkUrl) {
    return <div className="banner-slider">{img}</div>;
  }

  const isInternal = banner.linkUrl.startsWith("/");
  if (isInternal) {
    return (
      <div className="banner-slider">
        <Link to={banner.linkUrl} aria-label={alt}>
          {img}
        </Link>
      </div>
    );
  }

  return (
    <div className="banner-slider">
      <a
        href={banner.linkUrl}
        target={banner.linkTarget || "_self"}
        rel={banner.linkTarget === "_blank" ? "noopener noreferrer" : undefined}
        aria-label={alt}
      >
        {img}
      </a>
    </div>
  );
};

function SimpleSlider() {
  const { data, isLoading, error } = useGetBanners();
  const banners = Array.isArray(data?.banners) ? data.banners : [];

  const settings = {
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: banners.length > 1,
    infinite: banners.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  if (isLoading) {
    return (
      <div className="banner-slider-container">
        <div className="banner-slider">
          <Skeleton height={400} count={1} />
        </div>
      </div>
    );
  }

  if (error || banners.length === 0) {
    return (
      <div className="banner-slider-container">
        <div className="banner-slider banner-slider--placeholder">
          <Skeleton height={400} count={1} />
        </div>
      </div>
    );
  }

  return (
    <div className="banner-slider-container">
      <Slider {...settings} className="banner-slide">
        {banners.map((banner, index) => (
          <BannerSlide key={banner._id || banner.imageUrl || index} banner={banner} />
        ))}
      </Slider>
    </div>
  );
}

export default SimpleSlider;
